export type About = {
  title: string;
  picture: string;
  fullDescription: string;
  shortDescription: string;
};

export const WHO_WE_ARE: About[] = [
  {
    title: 'Who We Are',
    fullDescription:
      "Green Line Logistics is more than a freight carrier — we are a structured ecosystem of dedicated professionals united by one goal: to move freight smarter, safer, and greener. Through our network of autonomous Pods and specialized Cells, we provide seamless logistics solutions across the nation’s busiest lanes. With a culture rooted in accountability, innovation, and client-focused service, we deliver not just loads, but trust, reliability, and long-term partnerships.",
    shortDescription:
      "Green Line Logistics is more than a freight carrier — we are a structured ecosystem of dedicated professionals united by one goal: to move freight smarter, safer, and greener.",
    picture: '/images/who-we-are.webp',
  },
  {
    title: 'Our Mission',
    fullDescription:
      'Filling every mile - smarter, safer, greener freight across the busiest transportation lanes.',
    shortDescription:
      'Filling every mile - smarter, safer, greener freight across the busiest transportation lanes.',
    picture: '/images/our-mission.webp',
  },
];
